import {
  Card,
  CardHead,
  Header,
  HeaderArt,
  HeaderSub,
  HeaderTitle,
  List,
  Num,
  SecHead,
  Section,
  TwoCol,
  WarnBanner,
  Wrap,
} from './guideUi';

/** 차량 인수 / 반납 안내 — 네이티브 인포그래픽. */
const PickupReturnGuide = () => {
  return (
    <Wrap>
      <Header>
        <HeaderArt aria-hidden>
          <svg viewBox='0 0 48 48' fill='none'>
            <circle
              cx='18'
              cy='18'
              r='8'
              fill='rgba(255,255,255,0.16)'
              stroke='#fff'
              strokeWidth='2'
            />
            <path
              d='M24 24l14 14M32 32l4-4M28 36l4-4'
              stroke='#fff'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </HeaderArt>
        <HeaderTitle>차량 인수 / 반납 안내</HeaderTitle>
        <HeaderSub>인수·반납 시간과 절차를 확인하세요.</HeaderSub>
      </Header>

      <Section>
        <SecHead>
          <Num>1</Num> 인수 · 반납 시간
        </SecHead>
        <TwoCol>
          <Card>
            <CardHead>인수 가능시간</CardHead>
            <List>
              <li>08:00 ~ 22:00</li>
            </List>
          </Card>
          <Card>
            <CardHead>반납 가능시간</CardHead>
            <List>
              <li>06:00 ~ 20:00</li>
            </List>
          </Card>
        </TwoCol>
        <WarnBanner>
          ⚠️ 새벽 06:00~07:30 반납비용 1만원 / 야간 22:00~ 배차 불가
        </WarnBanner>
      </Section>

      <Section>
        <SecHead>
          <Num>2</Num> 인수 방법
        </SecHead>
        <List as='ol'>
          <li>
            제주공항 5번 게이트 → 횡단보도 건너 렌트카하우스 제8구역 3번
            주차구역의 셔틀버스 탑승 후 본사 이동(약 10~15분).
          </li>
          <li>
            인수 예정일 전 문자로 인수장소를 안내드립니다. 문자를 꼭 확인해
            주세요.
          </li>
          <li>차량 상태·연료 확인 후 인수(인수 시 사진 촬영 필수).</li>
          <li>반납은 인수하신 본사로만 가능하며 외부 반납은 불가합니다.</li>
        </List>
      </Section>
    </Wrap>
  );
};

export default PickupReturnGuide;
